import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[accordionContent]',
    standalone: false
})
export class AccordionContentDirective {
  constructor(public templateRef: TemplateRef<any>) {}
}
